export const TruckTypes = ['軽貨物', '2t', '4t', '10t', '20t'];
export type TruckType = typeof TruckTypes[number];

type TruckEntityBase = {
  garage_id: number | '';
  license_plate_value: string; // ナンバープレート番号
  truck_number: string; // 車番
  partner_company_id: number; // 運送会社
  partner_company_name?: string; // 運送会社
  loading_platform_height_cm?: number; // 荷台高
  loading_platform_length_cm?: number; // 荷台高
  loading_platform_width_cm?: number; // 荷台高
  group_ids: number[];
  last_shift_end_at?: string;
  driver_name?: string;
  max_num_pistons?: number;
  sort_order: number;
  temporary?: boolean;
} & TruckDetailFields;

export type TruckRequestEntity = TruckEntityBase;
export type TruckEntity = TruckEntityBase & {
  id: number,
  company_id?: number;
  driver_names?: string;// 'ドライバー名,ドライバー名,ドライバー名'
  company_name?: string;
  garage_name?: string;
  garage_address?: string;
};

export type TruckDetailFields = {
  maximum_loading_capacity_kg: number; // 最大積載重量
  loading_platform_volume_m3?: number;
  max_num_pistons?: number;
  max_num_locations_per_pistons?: number;
  maximum_loading_rate?: number; // 最大積載率
  minimum_loading_rate?: number; // 最小積載率
  klass?: TruckType;
  car_model?:
    | '平ボディ'
    | 'バンボディ'
    | 'ウィングボディ'
    | '保冷車'
    | '冷凍車'
    | '車載車'
    | '重機運搬車'
    | '危険物運搬車'
    | 'ダンプ'
    | '幌'
    | 'ユニック'
    | '海上コンテナー用'; // 車種
  floor_specification?: '鉄板' | 'ステンレス' | 'ジョルダー' | '縞板'; // 床仕様
  loading_platform_height?: '標準' | '低床' | '中低床'; // 荷台高の種別
  loading_platform_width?: '標準' | 'セミワイド' | 'ワイド'; // 荷台幅の種別
  loading_platform_length?: '大型' | '中型' | '小型' | 'ショート' | 'ロング'; // 荷台長の種別
  features?: ('パワーゲート' | '空調' | 'エアサス' | 'スタンション')[]; // 装置・特徴
  truck_fuel_cost_yen_per_km?: number // トラックの燃料費
  truck_insurance_fee_yen_per_day?: number // トラックの保険料
  truck_repair_cost_yen_per_day?: number // トラックの修繕費
  truck_expressway_fee_yen_per_shift?: number // トラックの高速代
}
